/* src/components/radio-group/radio-group.component.scss */
.radio-group {
  margin: -15px 0 20px calc(1.25rem + var(--vwui-size-spacing-sm));
  display: block;
}
.radio-group vwui-radio {
  display: block;
}
/*# sourceMappingURL=radio-group.component-C3AKCLWF.css.map */
